/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card } from 'react-bootstrap';

import Modal from 'react-modal';
import * as S from './styles';
import './styles.css';

import QRCode from 'react-qr-code';
import { XCircleIcon } from '@heroicons/react/solid';

export interface IQRModalProps {
  showModal: boolean;
  closeModal?(): void;
  qrValue?: string;
  [key: string]: any;
}

export const QRModal = ({ showModal, closeModal, qrValue }: IQRModalProps) => {
  if (qrValue) {
    return (
      <Modal
        isOpen={showModal}
        style={S.ModalStyle}
        onRequestClose={closeModal}
        className="qr-modal"
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'center',
          }}
        >
          <Card className="p-5">
            <XCircleIcon
              onClick={closeModal}
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                cursor: 'pointer',
              }}
              className="icon icon-sm ms-2"
            />
            <QRCode
              size={256}
              style={{
                height: 'auto',
                maxWidth: '100%',
                width: '100%',
              }}
              value={qrValue}
              viewBox={`0 0 256 256`}
            />
          </Card>
        </div>
      </Modal>
    );
  }
  return null;
};

QRModal.defaultProps = {
  showModal: false,
};
